const binding = { modules: {}, dataActions: {} };

    (binding.modules['text-block'] = {
        c: () => require('@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'text-block',
        p: 'text-block',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|themes|memoryexpress|views|text-block'] = {
                c: () => require('partner/themes/memoryexpress/views/text-block.view.tsx'),
                cn: '__local__-__local__-text-block'
            };
viewDictionary['@msdyn365-commerce-modules|text-block|modules|text-block|text-block'] = {
                c: () => require('@msdyn365-commerce-modules/text-block/dist/lib/modules/text-block/text-block.view.js'),
                cn: '@msdyn365-commerce-modules-text-block-text-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };